<template>
  <div class="overflow-x-auto whitespace-nowrap">
    <slot />
  </div>
</template>
